import { useEffect, useState } from "react";
import _ from "lodash";
import { applyPlatformDefaultsToGenerateCampaign } from "./applyPlatformDefaultsToGenerateCampaign";
import { applyResumeValuesToGenerateCampaign } from "./applyResumeValuesToGenerateCampaign";
import { useAdvertiserPlatformDefaults } from "./useAdvertiserPlatformDefaults";

export const usePlatformDefaultsInGenerateCampaign = ({
  platform,
  setValue,
  getValues,
  resumeValues = null,
  resumeFieldAliases = null,
}) => {
  const { platformDefaults, isLoaded } = useAdvertiserPlatformDefaults({
    platforms: platform ? [platform] : [],
    enabled: Boolean(platform),
  });
  const [resumeSettled, setResumeSettled] = useState(!resumeValues);

  useEffect(() => {
    if (!isLoaded) return;

    const data = platformDefaults[platform];
    if (data && !_.isEmpty(data)) {
      applyPlatformDefaultsToGenerateCampaign({
        platform,
        data,
        setValue,
      });
    }

    if (resumeValues) {
      applyResumeValuesToGenerateCampaign({
        resumeValues,
        getValues,
        setValue,
        resumeFieldAliases,
      });
      setResumeSettled(true);
    }
    // Apply once per completed load. Do not re-apply if setValue identity churns.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, platform, platformDefaults, resumeValues, resumeFieldAliases]);

  return {
    isLoadingDefaults: !isLoaded,
    resumeSettled: !resumeValues || resumeSettled,
  };
};
